import { createRouter, createWebHistory } from 'vue-router';
import LoginView from '@/views/LoginView.vue';
import AdminPanel from '@/views/AdminPanel.vue';
import Usermanager from '@/components/AdminPanel/UserManager.vue';
import Classvideo from '@/components/AdminPanel/ClassVideo.vue'
import Classmanager from '@/components/AdminPanel/ClassManager.vue';
import Resourcemanager from '@/components/AdminPanel/ResourceManager.vue'
import PublicResourceManager from '@/components/AdminPanel/PublicResourceManager.vue';
import UserPanel from '@/views/UserPanel.vue';
import StudentClass from '@/components/UserPanel/StudentClass.vue';
import StudentOnClass from '@/components/UserPanel/StudentOnClass.vue';
import { checkUserTypeAndToken } from '@/services/auth-guard';
import StudentResource from '@/components/UserPanel/StudentResource.vue';
import StudentVideo from '@/components/UserPanel/StudentVideo.vue'
import ClassBrief from '@/components/AdminPanel/ClassBrief.vue'
import StudentClassBrief from '@/components/UserPanel/StudentClassBrief.vue';
import StudentPublicResource from '@/components/UserPanel/StudentPublicResource.vue';

const routes = [
    {
        path: '/',
        redirect: '/loginview'
    },
    {
        path: '/loginview',
        name: 'loginview',
        component: LoginView
    },
    {
        path: '/adminpanel',
        name: 'adminpanel',
        component: AdminPanel,
        redirect: '/adminpanel/usermana',
        children: [

            {
                path: 'usermana',
                component: Usermanager
            },
            {
                path: 'classmana',
                name: 'classmana',
                component: Classmanager
            },
            {
                path: 'resourcemana/:courseId/:courseName',
                name: 'resourcemana',
                component: Resourcemanager
            },
            {
                path: 'classvideo/:fileUrl/:courseId',
                name: 'classvideo',
                component: Classvideo
            },
            // 课程简介页路由
            {
                path: 'classbrief/:courseId',
                name: 'classbrief',
                component: ClassBrief
            },
            // 公共资料页
            {
                path: 'publicresourcemana',
                name: 'publicresourcemana',
                component: PublicResourceManager
            }
        ]
    },
    {
        path: '/userpanel',
        name: 'userpanel',
        component: UserPanel,
        redirect: '/userpanel/studentclass',
        children: [
            {
                path: 'studentclass',
                name: 'studentclass',
                component: StudentClass
            },
            {
                path: 'studentonclass',
                name: 'studentonclass',
                component: StudentOnClass
            },
            {
                path: 'studentresource/:courseId/:courseName',
                name: 'studentresource',
                component: StudentResource
            },
            {
                path: 'studentvideo/:fileUrl/:courseId',
                name: 'studentvideo',
                component: StudentVideo
            },
            // 课程简介页路由
            {
                path: 'studentclassbrief/:courseId',
                name: 'studentclassbrief',
                component: StudentClassBrief
            },
            // 公共资料页
            {
                path: 'studentpublicresource',
                name: 'studentpublicresource',
                component: StudentPublicResource
            }
        ]
    },

    {
        path: '/:pathMatch(.*)*',
        redirect: '/loginview'
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach((to, from, next) => {
    if (!checkUserTypeAndToken() && to.name !== 'loginview') {
        next({ name: 'loginview' });  // 如果检查失败并且目标不是登录页面，则重定向到登录页面
    } else {
        next();  // 否则正常导航
    }
});

export default router;
